var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card page-max" },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: { model: _vm.ruleForm, "label-width": "180px" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c("el-form-item", { attrs: { label: "商品主图：" } }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "upLoadPicBox",
                        on: {
                          click: function ($event) {
                            return _vm.modalPicTap("1")
                          },
                        },
                      },
                      [
                        _vm.mealImg
                          ? _c("div", { staticClass: "pictrue" }, [
                              _c("img", { attrs: { src: _vm.mealImg } }),
                            ])
                          : _c("div", { staticClass: "upLoad" }, [
                              _c("i", {
                                staticClass: "el-icon-camera cameraIconfont",
                              }),
                            ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.mealImg
                      ? _c("i", {
                          staticClass: "el-icon-delete",
                          staticStyle: { color: "red", "font-size": "16px" },
                          on: {
                            click: function ($event) {
                              return _vm.removeImg("image")
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商品轮播图：", prop: "images" } },
                [
                  _c(
                    "div",
                    { staticClass: "slider-images upLoadPicBox" },
                    [
                      _c(
                        "SortImgVue",
                        {
                          attrs: {
                            imgUrlList: _vm.ruleForm.images,
                            changeList: _vm.changeSliderImages,
                          },
                        },
                        [
                          _c("div", { staticClass: "upLoad" }, [
                            !_vm.ruleForm.images ||
                            _vm.ruleForm.images.length < 10
                              ? _c("i", {
                                  staticClass: "el-icon-camera cameraIconfont",
                                  on: { click: _vm.upLoadSliderImages },
                                })
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "拼团名称：",
                    prop: "combinationName",
                    rules: [
                      {
                        required: true,
                        message: "请填写",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写" },
                    model: {
                      value: _vm.ruleForm.combinationName,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "combinationName", $$v)
                      },
                      expression: "ruleForm.combinationName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "活动日期：", prop: "activeRange" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      clearable: "",
                    },
                    model: {
                      value: _vm.ruleForm.activeRange,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "activeRange", $$v)
                      },
                      expression: "ruleForm.activeRange",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tips" }, [
                    _vm._v(
                      "设置活动开始结束时间，用户可以在设置时间内发起参与拼团"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "拼团时效（小时）：",
                    prop: "effectiveTime",
                    rules: [
                      {
                        required: true,
                        message: "请填写",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, placeholder: "请填写" },
                    model: {
                      value: _vm.ruleForm.effectiveTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "effectiveTime", $$v)
                      },
                      expression: "ruleForm.effectiveTime",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tips" }, [
                    _vm._v(
                      "用户发起拼团后开始计时，需在设置时间内邀请到规定好友人数参团；超过时效时间，则系统判定拼团失效，自动发起退款"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "拼团人数：", prop: "people" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, placeholder: "请填写" },
                    model: {
                      value: _vm.ruleForm.people,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "people", $$v)
                      },
                      expression: "ruleForm.people",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "参与次数：", prop: "quota" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, placeholder: "请填写" },
                    model: {
                      value: _vm.ruleForm.quota,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "quota", $$v)
                      },
                      expression: "ruleForm.quota",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tips" }, [
                    _vm._v(
                      "活动时间内每个用户参与拼团的次数限制。例如设置为4，表示本次活动有效期内，每个用户最多可参与购买4次"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "单次购买数量限制：", prop: "onceQuota" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, placeholder: "请填写" },
                    model: {
                      value: _vm.ruleForm.onceQuota,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "onceQuota", $$v)
                      },
                      expression: "ruleForm.onceQuota",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tips" }, [
                    _vm._v(
                      "用户参与拼团时，一次购买最大数量限制。例如设置为2，表示参与拼团时，用户一次购买数量最大可选择2"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "补齐人数：", prop: "fillPeople" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, placeholder: "请填写" },
                    model: {
                      value: _vm.ruleForm.fillPeople,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "fillPeople", $$v)
                      },
                      expression: "ruleForm.fillPeople",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tips" }, [
                    _vm._v(
                      "当用户参与拼团后，成团时效内未成团情况下，设置补齐人数可虚拟成团。例如成团人数为10人，补齐人数为4，真实用户需要参与6人成团才可以在最后未成团时自动补齐虚拟人员"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "物流方式：", prop: "name" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.ruleForm.logisticsType,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "logisticsType", $$v)
                        },
                        expression: "ruleForm.logisticsType",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "1" } }, [
                        _vm._v("到店自提"),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "2" } }, [
                        _vm._v("快递"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.ruleForm.logisticsType &&
              _vm.ruleForm.logisticsType.length &&
              _vm.ruleForm.logisticsType.includes("2")
                ? _c(
                    "el-form-item",
                    { attrs: { label: "运费设置：", prop: "shippingType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "small" },
                          model: {
                            value: _vm.ruleForm.shippingType,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "shippingType", $$v)
                            },
                            expression: "ruleForm.shippingType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("固定运费"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("运费模版"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.ruleForm.shippingType == 1
                        ? _c("el-input-number", {
                            staticStyle: { width: "400px" },
                            attrs: { min: 0, placeholder: "请填写" },
                            model: {
                              value: _vm.ruleForm.shippingFee,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "shippingFee", $$v)
                              },
                              expression: "ruleForm.shippingFee",
                            },
                          })
                        : _vm.ruleForm.shippingType == 0
                        ? _c(
                            "el-select",
                            {
                              staticStyle: { width: "400px" },
                              attrs: { placeholder: "请选择", clearable: "" },
                              model: {
                                value: _vm.ruleForm.tempId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "tempId", $$v)
                                },
                                expression: "ruleForm.tempId",
                              },
                            },
                            _vm._l(_vm.shippingList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "拼团状态：", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.ruleForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "status", $$v)
                        },
                        expression: "ruleForm.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("开启")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("关闭")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序：", prop: "sort" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, placeholder: "请填写" },
                    model: {
                      value: _vm.ruleForm.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "sort", $$v)
                      },
                      expression: "ruleForm.sort",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "规格选择：", prop: "name" } },
                [
                  _c(
                    "el-table",
                    {
                      ref: "tableListRef",
                      staticClass: "table",
                      attrs: {
                        data: _vm.skuLists,
                        size: "mini",
                        height: "300",
                        "highlight-current-row": "",
                        "header-cell-style": { fontWeight: "bold" },
                      },
                      on: { "selection-change": _vm.handleSelectionChange },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", width: "55" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "id", label: "ID", width: "60" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "图片", width: "80" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.attrImage
                                  ? _c(
                                      "div",
                                      { staticClass: "demo-image__preview" },
                                      [
                                        _c("el-image", {
                                          staticStyle: {
                                            width: "36px",
                                            height: "36px",
                                          },
                                          attrs: {
                                            src: scope.row.attrImage,
                                            "preview-src-list": [
                                              scope.row.attrImage,
                                            ],
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "suk",
                          label: "规格",
                          "min-width": "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "otPrice",
                          label: "默认售价",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "supplyPrice",
                          label: "供货价",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "cpSupplyPrice",
                          label: "集采供货价",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "stock",
                          label: "库存数量",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "defaultPrice",
                          label: "默认拼团价",
                          "min-width": "100",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input-number", {
                                  attrs: {
                                    min: 0,
                                    controls: false,
                                    size: "mini",
                                  },
                                  model: {
                                    value: scope.row.defaultPrice,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "defaultPrice", $$v)
                                    },
                                    expression: "scope.row.defaultPrice",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "num",
                          label: "拼团库存",
                          "min-width": "100",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input-number", {
                                  attrs: {
                                    min: 0,
                                    controls: false,
                                    size: "mini",
                                  },
                                  model: {
                                    value: scope.row.num,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "num", $$v)
                                    },
                                    expression: "scope.row.num",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", [
                _c(
                  "div",
                  { staticStyle: { "text-align": "center" } },
                  [
                    !_vm.details ||
                    !_vm.details.status ||
                    _vm.details.status == 0
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", loading: _vm.loading },
                            on: {
                              click: function ($event) {
                                return _vm.handerSubmit("ruleForm")
                              },
                            },
                          },
                          [_vm._v("确认提交")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-button", { on: { click: _vm.goReturn } }, [
                      _vm._v("返回列表"),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }